import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { User } from 'src/app/model/user.model';
import { ExcelService } from 'src/app/services/excel/excel.service';
import { ClipboardService } from 'ngx-clipboard';
import { environment } from 'src/environments/environment';

import * as XLSX from 'xlsx';
import { BranchDataDTO } from 'src/app/model/branch-data-dto.model';
import { registerOnlyUserDTOs } from 'src/app/model/registerOnlyUserDTOs.model';
import { DriveService } from 'src/app/services/drive/drive.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { ErrorStatusDialogComponent } from '../error-status-dialog/error-status-dialog.component';
import { MatDialog, MatSnackBar } from '@angular/material';
@Component({
  selector: 'app-recent-drive-event',
  templateUrl: './recent-drive-event.component.html',
  styleUrls: ['./recent-drive-event.component.scss']
})
export class RecentDriveEventComponent implements OnInit {
  @Input('branch') branch: any;
  @Input('data') data: any;
  @Output() branchDataEvent = new EventEmitter<string>();
  values: any = [];
  userListExcelDownload: User[] = [];
  excelDownloadData: any = [];
  registrationLink: any;
  attendanceLink: any;
  arrayBuffer: any;
  excelData: any;
  allUser: User[] = [];
  branchDataDto: registerOnlyUserDTOs = new registerOnlyUserDTOs();

  sNoCount: number;
  fullNameCount: number;
  phoneNumberCount: number;
  GenderCount: number;
  emailIdCount: number;
  qualificationCount: number;
  yearOfPassingCount: number;
  permanentCount: number;
  currentPincodeCount: number;
  errorFieldArray: string[];
  referralContactNumberCount: number;
  referralNameCount: number;
  branchId: any;
  constructor(private excelService: ExcelService,
    private driveService: DriveService,
    private utility: UtilityService,
    public dialog: MatDialog,
    private snackBarService: MatSnackBar,
    private clipboardService: ClipboardService) { }

  ngOnInit() {
    // this.branch.eventDate=new Date();
    // console.log("this.branch inside ngoninit: ", this.branch);
    
    this.branch.eventTime = '07-01-2019 ' + this.branch.eventTime;
    console.log('branch in recent-->', this.branch);
    this.branchDataEvent.emit(this.branch[0]);

  }
  //   download() {
  //     const fileName: any = this.branch.driveName;
  //      this.values = this.branch.registeredUsers;
  //  this.userListExcelDownload = this.values;

  //  if (this.values === null) {
  //    const excelDownloadModel: any = new class {
  //      'S.NO': ''; 'Full Name': ''; 'Phone Number': ''; 'Gender': ''; 'Email id': '';
  //      'Qualification': ''; 'Year Of Passing': ''; 'Registered Date': ''; 'Permanent Pin Code': ''; 'Current Pin Code': '';
  //    };

  //    excelDownloadModel['S.NO'] = '';
  //    excelDownloadModel['Full Name'] = '';
  //    excelDownloadModel['Phone Number'] = '';
  //    excelDownloadModel['Gender'] = '';
  //    excelDownloadModel['Email id'] = '';
  //    excelDownloadModel['Qualification'] = '';
  //    excelDownloadModel['Year Of Passing'] = '';
  //    excelDownloadModel['Registered Date'] = '';
  //    excelDownloadModel['Permanent Pin Code'] = '';
  //    excelDownloadModel['Current Pin Code'] = '';
  //    this.excelDownloadData.push(excelDownloadModel);
  //    this.excelService.exportAsExcelFile(this.excelDownloadData, fileName);
  //  } else {

  //    let rowNumber = 0;

  //    for (const response of this.userListExcelDownload) {
  //      const excelDownloadModel: any = new class {
  //        'S.NO': ''; 'Full Name': ''; 'Phone Number': ''; 'Gender': ''; 'Email id': '';
  //        'Qualification': ''; 'Year Of Passing': ''; 'Registered Date': ''; 'Permanent Pin Code': ''; 'Current Pin Code': '';
  //      };
  //      excelDownloadModel['S.NO'] = ++rowNumber;
  //      excelDownloadModel['Full Name'] = response.fullName;
  //      excelDownloadModel['Phone Number'] = response.phoneNumber;
  //      excelDownloadModel['Gender'] = response.gender;
  //      excelDownloadModel['Email id'] = response.emailId;
  //      excelDownloadModel['Qualification'] = response.qualification;
  //      excelDownloadModel['Year Of Passing'] = response.graduationYear;
  //      excelDownloadModel['Registered Date'] = response.registeredDate;
  //      excelDownloadModel['Permanent Pin Code'] = response.permanentPinCode;
  //      excelDownloadModel['Current Pin Code'] = response.currentPinCode;
  //      this.excelDownloadData.push(excelDownloadModel);
  //    }
  //    this.excelService.exportAsExcelFile(this.excelDownloadData, fileName);
  //  }
  //  this.excelDownloadData = [];
  //   }
  copyUrl() {
    this.registrationLink = environment.campaignUrl1 + this.branch.shortName;
    this.clipboardService.copyFromContent(this.registrationLink);
    this.snackBarService.open('Copied to clipboard', '', { duration: 2000 });
  }

  copyAttendanceUrl() {
    this.attendanceLink = environment.attendanceUrl + this.branch.shortName;
    this.clipboardService.copyFromContent(this.attendanceLink);
    this.snackBarService.open('Copied to clipboard', '', { duration: 2000 });
  }
  // }

  // @

  // @

  // v

  // arrayBuffer: any;
  // excelData: any;
  // userListExcelDownload: User[] = [];
  // excelDownloadData: any = [];
  // allUser: User[] = [];
  // branchDataDto: registerOnlyUserDTOs = new registerOnlyUserDTOs();
  // constructor(private excelService: ExcelService,
  //   private driveService: DriveService,
  //   private utility: UtilityService,
  //   public dialog: MatDialog,
  //   private snackBarService: MatSnackBar) { }

  // ngOnInit() {
  //   //this.branch.eventDate=new Date();
  //   this.branch.eventTime = "07-01-2019 " + this.branch.eventTime;
  //   console.log('branch in recent-->', this.branch);
  // }
  checkboxClick(branch , event){
    console.log("branch data: ", branch);
    console.log("event on checkbox : " , event);
    console.log("value for branch.checked: " , branch.checked);

    this.branchDataEvent.emit(branch);
  }

  download() {
    this.values = [];
    const fileName: any = this.branch.driveName;
    console.log("THIS.BRANCH BEFORE 144----------------", this.branch);
    var index = -1;
    // this.values = this.branch.attendedUsers;
    this.branch.attendedUsers.forEach(element => {
      if (this.values.length > 1) {
        // this.values.forEach(element => {
        //   index = this.values.indexOf(element);
        // });
        for (var i = 0; i < this.values.length; i++) {
          index = this.values.indexOf(element); 
        }
      }
      console.log("153  : ", index);
      if (this.values.length == 0) {
        this.values.push(element);
      } else {
        if (index == -1) {
          this.values.push(element);
        }
      }
    });
    console.log("ATTENDED USER", this.branch.attendedUsers);

    console.log("TESTING VALUES : ", this.values);

    if (this.branch.walkinUsers.length > 0) {
      for (let i = 0; i < this.branch.walkinUsers.length; i++) {
        // console.log("this.branch.walkinUsers.length------------147--", this.branch.walkinUsers.length);

        this.values.push(this.branch.walkinUsers[i]);
      }
      // console.log("this.branch.walkinUsers.length ", this.branch.walkinUsers.length);
      // console.log("this.branch.walkinUsers ", this.branch.walkinUsers);
      // console.log("this.values.length 151------------------------", this.values.length);


      // this.values.push(this.branch.walkinUsers);
    }
    // console.log("this.values:146 ", this.values);
    this.userListExcelDownload = this.values;
    // this.values = [];
    // console.log("this.values 159----------", this.values);


    if (this.values.length === 0) {
      const excelDownloadModel: any = new class {
        'S.NO': ''; 'Full Name': ''; 'Phone Number': ''; 'Gender': ''; 'Email id': '';
        'Qualification': ''; 'Year Of Passing': ''; 'Registered Date': ''; 'Permanent Pin Code': ''; 'Current Pin Code': ''; 'Refferal Name': ''; 'Refferal Contact No': '';
        'Status': '';
      };

      excelDownloadModel['S.NO'] = '';
      excelDownloadModel['Full Name'] = '';
      excelDownloadModel['Phone Number'] = '';
      excelDownloadModel['Gender'] = '';
      excelDownloadModel['Email id'] = '';
      excelDownloadModel['Qualification'] = '';
      excelDownloadModel['Year Of Passing'] = '';
      excelDownloadModel['Registered Date'] = '';
      excelDownloadModel['Permanent Pin Code'] = '';
      excelDownloadModel['Current Pin Code'] = '';
      excelDownloadModel['Status'] = '';
      excelDownloadModel['Refferal Name'] = '';
      excelDownloadModel['Refferal Contact No'] = '';

      this.excelDownloadData.push(excelDownloadModel);
      this.excelService.exportAsExcelFile(this.excelDownloadData, fileName);
    } else {

      let rowNumber: number = 0;

      for (const response of this.userListExcelDownload) {
        const excelDownloadModel: any = new class {
          'S.NO': ''; 'Full Name': ''; 'Phone Number': ''; 'Gender': ''; 'Email id': '';
          'Qualification': ''; 'Year Of Passing': ''; 'Registered Date': ''; 'Permanent Pin Code': ''; 'Current Pin Code': '';
          'Status': ''; 'Refferal Name': ''; 'Refferal Contact No': '';
        };
        excelDownloadModel['S.NO'] = ++rowNumber;
        excelDownloadModel['Full Name'] = response.fullName;
        excelDownloadModel['Phone Number'] = response.phoneNumber;
        excelDownloadModel['Gender'] = response.gender;
        excelDownloadModel['Email id'] = response.emailId;
        excelDownloadModel['Qualification'] = response.qualification;
        excelDownloadModel['Year Of Passing'] = response.graduationYear;
        excelDownloadModel['Registered Date'] = response.registeredDate;
        excelDownloadModel['Permanent Pin Code'] = response.permanentPinCode;
        excelDownloadModel['Current Pin Code'] = response.currentPinCode;
        excelDownloadModel['Status'] = response.status;
        excelDownloadModel['Referral Contact Number'] = response.referralContactNumber;
        excelDownloadModel['Referral Name'] = response.referralName;
        this.excelDownloadData.push(excelDownloadModel);
      }
      this.excelService.exportAsExcelFile(this.excelDownloadData, fileName);
      this.values = [];

    }
    this.excelDownloadData = [];
    // console.log("this.values: 210", this.values);

  }


  upload(event: any) {
    console.log(this.branch);
    this.allUser = [];
    this.sNoCount = 0;
    this.fullNameCount = 0;
    this.phoneNumberCount = 0;
    this.GenderCount = 0;
    this.emailIdCount = 0;
    this.qualificationCount = 0;
    this.yearOfPassingCount = 0;
    this.permanentCount = 0;
    this.currentPincodeCount = 0;
    this.errorFieldArray = [];

    console.log(event.target.files[0]);
    const file: File = event.target.files[0];
    event.target.value = null;
    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(file);
    fileReader.onload = () => {

      this.arrayBuffer = fileReader.result;
      const tempData = new Uint8Array(this.arrayBuffer);
      const arr = new Array();

      for (let i = 0; i !== tempData.length; ++i) {
        arr[i] = String.fromCharCode(tempData[i]);
      }

      const bstr = arr.join('');
      const workbook = XLSX.read(bstr, { type: 'binary' });
      const first_sheet_name = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[first_sheet_name];

      this.excelData = XLSX.utils.sheet_to_json(worksheet, { raw: true });

      console.log('-->', this.excelData);

      // for (const value of this.excelData) {

      //   const user: User = new User();
      //   user.rowNumber = value['S.NO'];
      //   user.fullName = value['Full Name'];
      //   user.phoneNumber = value['Phone Number'];
      //   user.gender = value.Gender;
      //   user.emailId = value['Email id'];
      //   user.qualification = value.Qualification;
      //   user.graduationYear = value['Year Of Passing'];
      //   user.permanentPinCode = value['Permanent Pin Code'];
      //   user.currentPinCode = value['Current Pin Code'];
      //   user.status = value['Status'];
      //   user.referralContactNumber = value['Referral Contact Number'];
      //   user.referralName = value['Referral Name']
      //   this.allUser.push(user);
      // }
      for (const value of this.excelData) {
        if(value['Status'] === 'selected' || value['Status'] === 'Selected' || value['Status'] === 'SELECTED'){
        const user: User = new User();
        user.rowNumber = value['S.NO'];
        if (user.rowNumber === undefined) {
          this.sNoCount++;
        }
        user.fullName = value['Full Name'];
        if (user.fullName === undefined) {
          this.fullNameCount++;
        }
        user.phoneNumber = value['Phone Number'];
        if (user.phoneNumber === undefined) {

          this.phoneNumberCount++;
        }
        user.gender = value.Gender;
        if (user.gender === undefined) {
          this.GenderCount++;
        }
        user.emailId = value['Email id'];
        if (user.emailId === undefined) {
          this.emailIdCount++;
        }
        user.qualification = value.Qualification;
        if (user.qualification === undefined) {
          this.qualificationCount++;
        }
        user.graduationYear = value['Year Of Passing'];
        if (user.graduationYear === undefined) {
          this.yearOfPassingCount++;
        }
        user.permanentPinCode = value['Permanent Pin Code'];
        if (user.permanentPinCode === undefined) {
          this.permanentCount++;
        }
        user.currentPinCode = value['Current Pin Code'];
        if (user.currentPinCode === undefined) {
          this.currentPincodeCount++;
        }
        user.referralContactNumber = value['Referral Contact Number'];
        //    if (user.referralContactNumber === undefined ) {
        //     this.referralContactNumberCount ++;
        //  }
        user.referralName = value['Referral Name']
        //    if (user.referralName === undefined ) {
        //     this.referralNameCount ++;
        //  }
        user.status = value['Status'];
        this.allUser.push(user);
      }
    }
      console.log('current count', this.currentPincodeCount);

      if (this.phoneNumberCount === this.allUser.length) {
        // console.log('phone number column in excel sheet invalid');
        // this.snackBarService.open('phone number column in excel sheet invalid', 'close',{duration: 5000});
        this.errorFieldArray.push('Phone Number');
      }
      if (this.sNoCount === this.allUser.length) {
        this.errorFieldArray.push('sr. No');
        //  this.snackBarService.open('s.no column invalid in excel sheet', 'close', {duration: 5000});
      }
      if (this.fullNameCount === this.allUser.length) {
        this.errorFieldArray.push('Full Name');
        // this.snackBarService.open('full name column invalid in excel sheet', 'close', {duration: 5000});
      }
      if (this.GenderCount === this.allUser.length) {
        this.errorFieldArray.push('Gender');
      }
      if (this.emailIdCount === this.allUser.length) {
        this.errorFieldArray.push('Email id');
      }
      if (this.qualificationCount === this.allUser.length) {
        this.errorFieldArray.push('Qualification');
        //this.snackBarService.open('qualification column invalid in excel sheet', 'close', {duration: 5000});
      }
      if (this.yearOfPassingCount === this.allUser.length) {
        this.errorFieldArray.push('Year Of Passing');

      }
      if (this.permanentCount === this.allUser.length) {
        this.errorFieldArray.push('Permanent Pin Code');
        // this.snackBarService.open('permanent pin code column invalid in excel sheet', 'close', {duration: 5000});
      }
      if (this.currentPincodeCount === this.allUser.length) {
        this.errorFieldArray.push('Current Pin Code');
        //this.snackBarService.open('current pin code column invalid in excel sheet', 'close', {duration: 5000});
      }
      if (this.referralContactNumberCount === this.allUser.length) {
        this.errorFieldArray.push('Refferal Contact Number');
      }
      if (this.referralNameCount === this.allUser.length) {
        this.errorFieldArray.push('Refferal Name');
      }

      if (this.errorFieldArray.length !== 0) {
        console.log('error in column-->', this.errorFieldArray);

        this.dialog.open(ErrorStatusDialogComponent, {
          width: '60%',
          data: {
            response: this.errorFieldArray,
            errorFor: 'column'
          }
        });
      }
      else {
        console.log(XLSX.utils.sheet_to_json(worksheet, { raw: true }));
        // console.log('all user', this.allUser);
        this.branchDataDto.registerOnlyUserDTOs = this.allUser;
        console.log('all user', this.branchDataDto.registerOnlyUserDTOs);
        console.log('excel data to upload--->', this.branchDataDto);
        this.driveService.uploadRecentDriveUser(this.branch.id, this.branchDataDto).subscribe(
          response => {
            this.utility.hideSpinner();
            console.log(response);
            //this.snackBarService.open((response as any).data.message, 'close', { duration: 4000 });
            this.snackBarService.open((response as any).message, 'close', { duration: 4000 });
            // this.branchDataDto = null;
            this.allUser = [];
            if (response.data.validationStatus === true) {
              this.dialog.open(ErrorStatusDialogComponent, {
                width: '60%',
                data: {
                  response: response,
                  errorFor: 'row'
                }
              });
            }
            if (response.data.statusCode === 1) {
              this.snackBarService.open('excel sheet upload successfully', 'close', { duration: 4000 });
            }
            // this.ngOnInit();


          }
        );
      }
    };
  }
}
